import {html, LitElement} from 'lit';
import {customElement, queryAssignedElements} from 'lit/decorators.js';
import {TabItem} from "@/components/tab-menu-item/tab-menu-item.ts";
import {searchFilterNavStyle} from "@/components/search-filter-nav/search-filter-nav.styles.ts";

// eslint-disable-next-line
declare let _paq: any

@customElement('sbk-search-filter-nav')
export class SbkSearchFilterNav extends LitElement {

    @queryAssignedElements({selector: 'sbk-tab-menu-item'})
    _tabItems!: Array<TabItem>

    static get styles() {
        return searchFilterNavStyle;
    }

    render() {
        return html`
            <sbk-tab-menu class="filter-nav" .fade=${false}>
                <slot @slotchange=${this._addResultAmount}></slot>
            </sbk-tab-menu>
        `;
    }


    private _addResultAmount() {
        if (this._tabItems.length) {
            this._tabItems.forEach(tabItem => {
                fetch(tabItem.href + '&type=2004', {
                    method: 'POST',
                })
                    .then((response) => {
                        return response.text()
                    })
                    .then((data) => {
                        let responseText = parseInt(data)
                        if (responseText >= 0) {
                            if (responseText > 999) {
                                responseText = 999
                            }
                            tabItem.querySelectorAll('span').forEach((spanItem) => {
                                spanItem.innerText = ` (${  responseText  })`;
                            })

                            if (tabItem.hasAttribute('active')) {
                                const category = tabItem.innerText.split('(')[0]
                                const count = responseText
                                const searchInput = document.querySelector('sbk-search')?.shadowRoot?.querySelector('#searchInput');
                                const searchWord = (<HTMLInputElement> searchInput).value;

                                _paq.push([
                                    'trackSiteSearch',
                                    // Search keyword searched for
                                    searchWord,
                                    // Search category selected in your search engine. If you do not need this, set to false
                                    category,
                                    // Number of results on the Search results page. Zero indicates a 'No Result Search Keyword'. Set to false if you don't know
                                    count,
                                ])
                            }
                        }
                    })
            });
        }
    }
}
